import CategoryWithHeadlinesService from './CategoryWithHeadlines.service';

type ServiceVariables = {
  channel: string | string;
  parent?: string;
  parentCategoryId?: number;
  slug?: string;
  domain?: string | string[];
  language?: string;
  page?: string;
  headlinesLimit?: number | undefined;
  getCount?: boolean;
  getViews?: boolean;
};

export async function fetchCategoryWithHeadlines(variables: ServiceVariables, { req }: { req: PortalRootIncomingMessage }) {
  const categoryWithHeadlinesService = new CategoryWithHeadlinesService({ req });
  const categoryData = await categoryWithHeadlinesService.fetch(variables);

  if (!categoryData?.category) {
    categoryWithHeadlinesService.handleError({ message: 'category.error.not_found', statusCode: 404 });
    return;
  }

  return categoryData;
}
